import { useField } from 'formik';

import { IconButton } from '../../../cdl/IconButton/IconButton';
import { FormikSwitch } from '../../../cdl/Switch/FormikSwitch';
import { Text } from '../../../cdl/Text/Text';
import { formatMoney } from '../../helpers/formatMoney.helper';
import { IconX } from '../../icons/cdl/X';
import { FormikMoneyInput } from '../../MoneyInput/FormikMoneyInput';
import { Td } from '../../Table/Td';
import { Tr } from '../../Table/Tr';
import { Box } from '../../ui/Box';
import { SurchargeName } from '../components/SurchargeName';
import { useProductTableConfig } from '../hooks/useProductTableConfig';
import { getSurchargeOrWaiverString } from '../utils/getSurchargeOrWaiverString';

interface SurchargeRowProps {
    name: string;
    onRowRemoveClicked: () => void;
}

export const SurchargeRow = (props: SurchargeRowProps) => {
    const [field] = useField(props.name);
    const surcharge = field.value;

    const { showPrices, editable, editSurcharges } = useProductTableConfig();

    const emptyColumns = showPrices ? 6 : 8;

    const canEditPrices = editable && editSurcharges;

    return (
        <Tr inactive={surcharge.deleted} focused={surcharge.added && !surcharge.deleted}>
            <Td>
                <SurchargeName name={props.name} editable={editable && editSurcharges} />
            </Td>
            <Td colSpan={emptyColumns}>
                <Text variant="small">{getSurchargeOrWaiverString(surcharge.value.value)}</Text>
            </Td>

            {showPrices ? (
                <>
                    <Td>
                        <Box display="grid">
                            {!canEditPrices ? (
                                <Text variant="small" textAlign="right">
                                    {formatMoney({
                                        value: surcharge.value.value,
                                        currency: surcharge.value.currency,
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                    })}
                                </Text>
                            ) : (
                                <FormikMoneyInput
                                    name={`${props.name}.value.value`}
                                    decimals={2}
                                    allowNegativeValue
                                    disabled={surcharge.deleted}
                                    required
                                />
                            )}
                        </Box>
                    </Td>
                    <Td>
                        <Box display="grid">
                            <Text variant="small" textAlign="right">
                                {formatMoney({
                                    value: surcharge.value.value,
                                    currency: surcharge.value.currency,
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                })}
                            </Text>
                        </Box>
                    </Td>
                </>
            ) : null}

            {editable ? (
                <Td>
                    {editSurcharges ? (
                        <Box display="flex" justifyContent="center">
                            {surcharge.new ? (
                                <IconButton type="button" onClick={props.onRowRemoveClicked} Icon={IconX} />
                            ) : (
                                <FormikSwitch
                                    disabled={
                                        surcharge.value?.value === undefined ||
                                        surcharge.value?.value?.toString() === ''
                                    }
                                    name={`${props.name}.deleted`}
                                    invert
                                />
                            )}
                        </Box>
                    ) : null}
                </Td>
            ) : null}
        </Tr>
    );
};
